import React, { useState, useEffect } from 'react';

import { useEscapeToClose } from '../../hooks/useEscapeToClose';
function ReportProgressModal({ progress, isComplete, onDismiss }) {
  useEscapeToClose(onDismiss);   // Escape dismisses this modal
  const [autoCloseTimer, setAutoCloseTimer] = useState(null);

  useEffect(() => {
    // Auto-close after 1 minute if complete
    if (isComplete && progress >= 100) {
      const timer = setTimeout(() => {
        onDismiss();
      }, 60000); // 60 seconds

      setAutoCloseTimer(timer);

      return () => clearTimeout(timer);
    }
  }, [isComplete, progress, onDismiss]);

  return (
  <div className="modal-overlay">
      <div className="progress-modal-box">
        <h2 className="progress-title">
          Generating Report
        </h2>

        {/* Progress Bar */}
        <div className="progress-bar-container">
          <div className="progress-bar-fill" style={{ width: `${progress}%` }}>
            {progress > 10 && `${progress}%`}
          </div>
          {progress <= 10 && (
            <div className="progress-bar-text">
              {progress}%
            </div>
          )}
        </div>

        {/* Status Messages */}
        {!isComplete && (
          <div className="progress-bar-text">
            {progress < 30 && 'Initializing report generation...'}
            {progress >= 30 && progress < 60 && 'Compiling your health data...'}
            {progress >= 60 && progress < 90 && 'Generating PDF document...'}
            {progress >= 90 && progress < 100 && 'Sending email to providers...'}
          </div>
        )}

        {isComplete && (
          <p className="progress-complete">
            Report Completed and Sent - click Dismiss to close window
          </p>
        )}

        {/* Dismiss Button */}
        <div className="flex-row-center">
          <button
            onClick={onDismiss}
            title="Dismiss for background processing"
            className="btn-primary-lg"
          >
            Dismiss
          </button>
        </div>
      </div>
    </div>
  );
}

export default ReportProgressModal;
